import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ProgressService {
    private hasCompletedStep1 = false;
    private hasCompletedStep2 = false;
    private hasCreatedAccount = false;

    constructor() { }

    completedStep1(): void {
        this.hasCompletedStep1 = true;
    }

    completedStep2(): void {
        this.hasCompletedStep2 = true;
    }

    accountCreated(): void {
        this.hasCreatedAccount = true;
    }

    isStep1Completed(): boolean {
        return this.hasCompletedStep1;
    }

    isStep2Completed(): boolean {
        return this.hasCompletedStep2;
    }

    isAccountCreated(): boolean {
        return this.hasCreatedAccount;
    }

    resetStepStates() {
        this.hasCompletedStep1 = false;
        this.hasCompletedStep2 = false;
        this.hasCreatedAccount = false;
    }
}
